export const ALLOW_DUPLICATED_PARTICIPANTS = Boolean(
  Number(process.env.MIX_ALLOW_DUPLICATED_PARTICIPANTS),
); // get the value 1 or 0 as a boolean since we get it as a string

export const ENABLE_MULTI_CAMERA_STREAM = Boolean(
  Number(process.env.MIX_ENABLE_MULTI_CAMERA_STREAM),
);

export const ENABLE_PARTIAL_SCREENSHARE = Boolean(
  Number(process.env.MIX_ENABLE_PARTIAL_SCREENSHARE),
);

export const ENABLE_TOUR_GUIDE = Boolean(Number(process.env.MIX_ENABLE_TOUR_GUIDE));

export const ENVIRONMENT = process.env.MIX_APP_ENV ?? 'local';

export const NODE_WEBSOCKET_ADDRESS = process.env.MIX_NODE_WEBSOCKET_ADDRESS;
export const NODE_WEBSOCKET_DOMAIN = process.env.MIX_NODE_WEBSOCKET_DOMAIN;
export const NODE_WEBSOCKET_PORT = process.env.MIX_NODE_WEBSOCKET_PORT;

export const IOT_WEBSOCKET_ADDRESS = process.env.MIX_IOT_WEBSOCKET_ADDRESS;
export const IOT_WEBSOCKET_DOMAIN = process.env.MIX_IOT_WEBSOCKET_DOMAIN;
export const IOT_WEBSOCKET_PORT = process.env.MIX_IOT_WEBSOCKET_PORT;

export const DEVICE_WEBSOCKET_ADDRESS = process.env.MIX_DEVICE_WEBSOCKET_ADDRESS;
export const DEVICE_WEBSOCKET_DOMAIN = process.env.MIX_DEVICE_WEBSOCKET_DOMAIN;
export const DEVICE_WEBSOCKET_PORT = process.env.MIX_DEVICE_WEBSOCKET_PORT;

export const CAM_LOCAL_STORAGE_KEY = '_vice-multi-camera_';
export const USER_SESSION_ACTIVITY_KEY = '_vice-user-session-activity';
export const USER_SESSION_ON_HOLD_KEY = '_vice-user-session-on-hold';

export const JITSI_URL = process.env.MIX_JITSI_URL;
export const JITSI_SERVER_DOMAIN = process.env.MIX_JITSI_SERVER_DOMAIN;

export const APP_DOMAIN = process.env.MIX_APP_DOMAIN;
export const APP_URL = process.env.MIX_APP_URL;

export const LARAVEL_ECHO_SERVER_HOST = process.env.MIX_LARAVEL_ECHO_SERVER_HOST;
// export const LARAVEL_ECHO_SERVER_PATH = process.env.MIX_LARAVEL_ECHO_SERVER_PATH;
export const LARAVEL_ECHO_SERVER_PORT = process.env.MIX_LARAVEL_ECHO_SERVER_PORT;
export const LARAVEL_ECHO_SERVER_SCHEME = process.env.MIX_LARAVEL_ECHO_SERVER_SCHEME;

export const DEVICE_SCREEN_SHARE_APP_URL = process.env.MIX_DEVICE_SCREEN_SHARE_APP_URL;
export const DEVICE_SCREEN_SHARE_APP_DOMAIN = process.env.MIX_DEVICE_SCREEN_SHARE_APP_DOMAIN;

export const CHAT_DOMAIN = process.env.MIX_CHAT_DOMAIN;

export const SUPPORT_URL = process.env.MIX_SUPPORT_URL;

export const COMMANDS = {
  RAISE_HAND: 'RAISE_HAND',
  GO_TO_NEXT_PHASE: 'GO_TO_NEXT_PHASE',
  PAUSE_CURRENT_PHASE: 'PAUSE_CURRENT_PHASE',
  MUTE_MEDIA: 'MUTE_MEDIA',
  MUTE_ALL_PARTICIPANTS: 'MUTE_ALL_PARTICIPANTS',
  SEND_VICE_MESSAGE: 'SEND_VICE_MESSAGE',
  MESSAGE_DISSMISED_COMMAND: 'messageDismissed',
  PUT_ON_HOLD: 'PUT_ON_HOLD',
  END_SCREENSHARE: 'END_SCREENSHARE',
  MUTE_SINGLE_PARTICIPANT: 'MUTE_SINGLE_PARTICIPANT',
  KICK_PARTICIPANT: 'KICK_PARTICIPANT',
};

export const SESSION_CALL_HELPERS = {
  RESET_SESSION: 'RESET_SESSION',
  HANDLE_NAVIGATION: 'HANDLE_NAVIGATION',
  ATTENDEE_END_PHASE: 'ATTENDEE_END_PHASE',
  CLINICIAN_END_PHASE: 'CLINICIAN_END_PHASE',
  CLINICIAN_SET_NEXT_PHASE: 'CLINICIAN_SET_NEXT_PHASE',
  INITIALIZE_CHAT_MESSAGES: 'INITIALIZE_CHAT_MESSAGES',
  UPDATE_SESSION_ANALYTICS: 'UPDATE_SESSION_ANALYTICS',
  CLINICIAN_BACK_TO_PREVIOUS_PHASE: 'CLINICIAN_BACK_TO_PREVIOUS_PHASE',
};

export const DISPLAY_NAME = {
  VUZIX: 'vuzix',
  NAVIGATION_USER: 'NavigationUser',
  OBSERVER: 'Observer',
  SCREENSHARE_USER: 'Clinician-ScreenshareUser',
  STETHOSCOPE: 'Clinician-Stethoscope',
  SMARTPHONE: 'Clinician-Smartphone',
};

export const CLINICIAN_STREAMS_TO_ALLOW_ONLY_IN_CONSULTATION = [
  DISPLAY_NAME.STETHOSCOPE,
  DISPLAY_NAME.VUZIX,
];

export const VICE_SESSION_PHASES = {
  INTRODUCTION: 1,
  CONSULTATION: 2,
  DEBRIEF: 3,
  SESSION_END: 4,
};

export const PHASE_STATUS = {
  WAITING: 'waiting',
  LIVE: 'live',
  COMPLETED: 'completed',

  PAUSED: 'paused',
  RESUMED: 'resumed',
  STARTED: 'started',
  ENDED: 'ended',
};

export const MEDIA_TYPE = {
  VIDEO: 'video',
  AUDIO: 'audio',
};

export const USER_ROLE = {
  CLINICIAN: 'clinician',
  PARTICIPANT: 'participant',
  OBSERVER: 'observer',
};

export const COMPONENT_EVENTS = {
  MUTE_PREVIEW_AUDIO: 'mutePreviewAudio',
  MUTE_PREVIEW_VIDEO: 'mutePreviewVideo',
};

export const VICE_MESSAGE_TYPE = {
  MESSAGE: 'message',
  SYSTEM_MESSAGE: 'system',
  ATTACHMENT: 'attachment',
};

export const SESSION_STATUS = {
  PUBLISH: 'publish',
  DRAFT: 'draft',
};

export const STETHOSCOPE_EVENTS = {
  JOIN: 'join',
  SIGNAL: 'signal',
  MESSAGE: 'message',
  CONNECT: 'connect',
  CONNECTION: 'connection',
  DISCONNECT: 'disconnect',
  DEVICE_DISCONNECTED: 'device-disconnected',
};

export const MEDIA_DEVICE_KIND = {
  AUDIO_INPUT: 'audioinput',
  AUDIO_OUTPUT: 'audiooutput',
  VIDEO_INPUT: 'videoinput',
};

export const DEVICE_NAME = {
  MICROPHONE: 'Microphone',
  SPEAKERS: 'Speakers',
  CAMERA: 'Camera',
};

export const DEVICE_TYPES = {
  MAIN_CAMERA: 'Main Camera',
  EXTRA_CAMERA: 'Extra Camera',
};

export const CAMERA_TYPES = {
  INTERNAL_WEBCAM: 'Internal Webcam',
  EXTERNAL_WEBCAM: 'External Camera',
  EXTERNAL_WEARABLE_CAMERA: 'External Wearable Camera',
};
export const MAX_FILE_SIZE = 25600;

export const MAX_CHAR_LENGTH = 1000;

export const NUMBER_OF_ALLOWED_CAMERAS = Number(process.env.MIX_NUMBER_OF_ALLOWED_CAMERAS) || 2;

export const VUZIX_EVENTS = {
  SET_SESSION_STATE: 'vuzix:set_session_state',
  SET_SPEAKER_STATE: 'vuzix:set_speaker_state',
  SET_MICROPHONE_STATE: 'vuzix:set_microphone_state',
  MESSAGE: 'vuzix:message',
  DISCONNECT: 'vuzix:disconnect',
  JOIN: 'vuzix:join',
};
export const TIMER_ACTION = {
  INCREASE: 'increase',
  DECREASE: 'decrease',
};

export const CONNECT_EXTERNAL_DEVICE_MODAL_LABELS = {
  Camera: {
    modalTitle: 'Select Camera',
    buttonLabel: 'Add Camera',
    displayName: '',
    deviceToAdd: 'Camera',
  },
  smartGlass: {
    modalTitle: 'Connect Smart Glasses',
    buttonLabel: 'Add Smart Glasses',
    displayName: DISPLAY_NAME.VUZIX,
    deviceToAdd: 'smartGlass',
  },
  stethoscope: {
    modalTitle: 'Select Medical Device',
    buttonLabel: '',
    displayName: DISPLAY_NAME.STETHOSCOPE,
    deviceToAdd: 'stethoscope',
  },
  smartphone: {
    modalTitle: 'Connect Smartphone',
    buttonLabel: 'Add Smartphone',
    displayName: DISPLAY_NAME.SMARTPHONE,
    deviceToAdd: 'smartphone',
  },
  Monitor: {
    modalTitle: 'Select Monitor',
    buttonLabel: 'Add Monitor',
    displayName: '',
    deviceToAdd: 'Monitor',
  },
};

export const EXTERNAL_CONNECTED_AUDIO_DEVICES = {
  STETHOSCOPE: 'Stethoscope',
};

export const EXTERNAL_CONNECTED_VIDEO_DEVICES = {
  OTOSCOPE: 'Otoscope',
  DERMATOSCOPE: 'Dermatoscope',
  MONITOR: 'Monitor',
};

export const SUPPORTS_SNAPSHOT = ['Dermatoscope', 'Otoscope', 'Smartphone', 'Monitor'];

export const ALERTS_SEEN_COOKIES_NAMES = {
  PROFILE_PICTURE_ALERT_SEEN: 'profile_picture_alert_seen',
  TWO_FACTOR_AUTH_ALERT_SEEN: 'two_factor_auth_alert_seen',
};

export const DERMATOSCOPE_LABELS = process.env.MIX_DERMATOSCOPE_LABELS
  ? JSON.parse(process.env.MIX_DERMATOSCOPE_LABELS)
  : ['Digital Microscope'];
export const OTOSCOPE_LABELS = process.env.MIX_OTOSCOPE_LABELS
  ? JSON.parse(process.env.MIX_OTOSCOPE_LABELS)
  : ['Digital Microscope'];
export const STETHOSCOPE_LABELS = process.env.MIX_STETHOSCOPE_LABELS
  ? JSON.parse(process.env.MIX_STETHOSCOPE_LABELS)
  : ['ri-sonic PCP'];
export const MONITOR_LABELS = process.env.MIX_MONITOR_LABELS
  ? JSON.parse(process.env.MIX_MONITOR_LABELS)
  : ['HDMI'];

export const AUDIO_MEDICAL_DEVICES = [...new Set([...STETHOSCOPE_LABELS])];
export const VIDEO_MEDICAL_DEVICES = [
  ...new Set([...DERMATOSCOPE_LABELS, ...OTOSCOPE_LABELS, ...MONITOR_LABELS]),
];

export const STREAM_TURNED_OFF_DURATION = 90000; // 1 minute 30 seconds or 90000 milliseconds

export const SMART_GLASS_DEVICE_LABEL = 'Smart glasses (Vuzix)';

export const MAX_OBSERVERS_AMOUNT = Number(process.env.MIX_MAX_OBSERVERS_AMOUNT);

export const ENABLE_SIMULCAST = Boolean(process.env.MIX_SIMULCAST_ENABLED === '1');

export const TURN_CREDENTIALS = process.env.MIX_TURN_CREDENTIALS;

export const SESSION_LOG_ENDPOINT = '/api/session-analytics/session/log';

export const TEST_IMAGE_CDN_URL = 'https://d3e1sbg7wnmnpx.cloudfront.net/test.jpg';
export const TEST_IMAGE_SIZE = 7336784;

export const INTERCOM_APP_ID = process.env.MIX_INTERCOM_APP_ID;

export const DEVICE_SLOT_ACTIONS = {
  ADD_DEVICE: 'addDevice',
  DELETE_DEVICE: 'deleteDevice',
};

export const DEVICES_KINDS = {
  AUDIO_INPUT: 'audioinput',
  AUDIO_OUTPUT: 'audiooutput',
  VIDEO_INPUT: 'videoinput',
  OTHER: 'other',
};
